import React from 'react';
import { Button, Empty } from '@routific/hive';
import styled from 'styled-components';
import ErrorImage from '../../images/error.svg';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-around;
  border-radius: 1px;
`;

const ErrorBody: React.FunctionComponent = () => {
  const { t } = useTranslation('components');
  return (
    <Container>
      <Empty
        style={{ width: '100%' }}
        size="large"
        title={t('errorBoundary.title')}
        image={ErrorImage}
        description={t('errorBoundary.description')}
        data-cy="error-boundary"
        button={
          <Space>
            <a href="mailto:support@routific.com?subject=Routific Support">
              <Button type="default">{t('errorBoundary.cta.contact')}</Button>
            </a>
            <Button type="primary" onClick={() => window.location.reload()}>{t('errorBoundary.cta.refresh')}</Button>
          </Space>
        }
      />
    </Container>
  );
};

export default ErrorBody;
